import { apps, safeNextPath } from '@hobbytools/platform';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

/** True when a same-origin path belongs to another app on the domain (needs a full page load). */
export function isOtherApp(path: string): boolean {
  return apps.some(
    (a) => a.id !== 'hub' && a.enabled && (path === a.base.slice(0, -1) || path.startsWith(a.base)),
  );
}

/** Where to send the user after auth: the validated `next` query param, or `fallback`. */
export function useNext(fallback = '/') {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const next = safeNextPath(params.get('next'), fallback);
  const go = useCallback(() => {
    if (isOtherApp(next)) window.location.assign(next);
    else navigate(next, { replace: true });
  }, [next, navigate]);
  return { next, go, query: next === fallback ? '' : `?next=${encodeURIComponent(next)}` };
}
